export const BASE_URL = '/gisbis'
export const DOC_PREVIEW_URL = '/gisbis/doc-service/GetDocPreview'
export const DOC_DOWNLOAD_URL = '/gisbis/GetDoc'
export const LAYER_SOURCE_URL = '../gisbis/MapProxy/layer'
